export const CURRENCY_COOKIE = 'displayCurrency';
export const COUNTRY_COOKIE = 'displayCountry';
export const LOCALE_COOKIE = 'preferredLocale';

export const SITE_COOKIE_MAX_AGE = 60 * 60 * 24 * 180;

/** A/B test arm. Not httpOnly on purpose: GTM labels events with it, BlueprintCard picks the link from it. */
export const OVERVIEW_EXPERIMENT_COOKIE = 'overviewExperiment';
